var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"individual-vendor-details"},[(_vm.loading)?_c('div',[_vm._v("loading")]):[_c('eden-page-header',{attrs:{"title":'Vendors',"subtitle":_vm.customerName}}),_c('div',[_c('OrderTypes',{attrs:{"data":_vm.vendorSummary}})],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }